import { render, staticRenderFns } from "./Customizer.vue?vue&type=template&id=daa68f6a"
import script from "./Customizer.vue?vue&type=script&lang=js"
export * from "./Customizer.vue?vue&type=script&lang=js"
import style0 from "./Customizer.vue?vue&type=style&index=0&id=daa68f6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports